import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { modalAnimations } from '@df/ui/modal/modal-animations';
import { ModalContainerAbstract } from '@df/ui/modal/modal-container.abstract';

/**
 * Internal component that wraps user-provided top modal content.
 */
@Component({
    selector: 'modal-top-container',
    template: `<ng-template cdkPortalOutlet />`,
    styleUrl: './modal-container.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [modalAnimations.modalTopContainer],
    host: {
        class: 'modal-container modal-top-container',
        tabindex: '-1',
        'aria-modal': 'true',
        '[attr.id]': 'id',
        '[attr.role]': 'config.role',
        '[attr.aria-labelledby]': 'config.ariaLabel ? null : ariaLabelledBy',
        '[attr.aria-label]': 'config.ariaLabel',
        '[attr.aria-describedby]': 'config.ariaDescribedBy || null',
        '(@modalTopContainer.start)': 'onAnimationStart($event)',
        '(@modalTopContainer.done)': 'onAnimationDone($event)'
    },
    standalone: true,
    imports: [CdkPortalOutlet]
})
export class ModalTopContainerComponent extends ModalContainerAbstract {
    @HostBinding('@modalTopContainer') get getModalContainer(): any {
        return this.animationState;
    }
}
